import * as Dialog from '@radix-ui/react-dialog';
import { Separator } from '@radix-ui/react-separator';
import { useTranslation } from 'react-i18next';
import { RxCross2 } from 'react-icons/rx';
import { MainCustomButton } from '../../../../components/Buttons';

const DialogCheckoutIsSecure = ({
  open,
  setOpen,
  onOK
}: {
  open: boolean;
  setOpen: (v: boolean) => void;
  onOK: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-20 data-[state=open]:animate-overlayShow" />
        <Dialog.Content className="fixed left-[50%] top-[50%] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white pt-4 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
          <Dialog.Title className="m-0 text-[17px] font-medium text-black">
            <h1 className="px-4 text-center">{t('checkoutIsSecureTitle')}</h1>
            <Separator className="mt-[15px] bg-slate-200 data-[orientation=horizontal]:h-px data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px" />
          </Dialog.Title>

          <Dialog.Description className="m-0 py-6 text-[14px] text-black">
            <h1 className="px-4 text-center">{t('checkoutIsSecureText')}</h1>
          </Dialog.Description>

          {/* <Separator className="bg-slate-200 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px mb-[15px]" /> */}

          <MainCustomButton
            className="m-auto mb-3 w-full md:w-full"
            text="OK"
            type="button"
            onClick={onOK}
          />

          <Dialog.Close asChild>
            <button
              className="absolute right-[10px] top-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full text-violet11 hover:bg-violet4 focus:shadow-[0_0_0_2px] focus:shadow-violet7 focus:outline-none"
              aria-label="Close"
            >
              <RxCross2 />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { DialogCheckoutIsSecure };
